/**
 * @generated SignedSource<<d6b7eef8b505fb877594e4673aa58c74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type preconfiguredSourcesQuery$variables = {};
export type preconfiguredSourcesQuery$data = {
  readonly preconfiguredSources: ReadonlyArray<{
    readonly configuration: {
      readonly fields: ReadonlyArray<{
        readonly description: string;
        readonly envVarName: string;
        readonly hint: string | null;
        readonly options: ReadonlyArray<string | null> | null;
        readonly order: number;
        readonly required: boolean;
        readonly secretName: string | null;
        readonly type: string;
        readonly visible: boolean;
      }>;
      readonly type: string;
    } | null;
    readonly displayName: string;
    readonly name: string;
    readonly provider: string;
    readonly stableVersion: string | null;
  }>;
};
export type preconfiguredSourcesQuery = {
  response: preconfiguredSourcesQuery$data;
  variables: preconfiguredSourcesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PreconfiguredSource",
    "kind": "LinkedField",
    "name": "preconfiguredSources",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stableVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Configuration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ConfigurationField",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secretName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "envVarName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "required",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visible",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hint",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "options",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "preconfiguredSourcesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "preconfiguredSourcesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d75caa799d1edc2857a9a68345d0980",
    "id": null,
    "metadata": {},
    "name": "preconfiguredSourcesQuery",
    "operationKind": "query",
    "text": "query preconfiguredSourcesQuery {\n  preconfiguredSources {\n    name\n    provider\n    displayName\n    stableVersion\n    configuration {\n      type\n      fields {\n        secretName\n        envVarName\n        description\n        required\n        visible\n        hint\n        type\n        order\n        options\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "600fba1dc3bc4a70bc5dc8009a22bdce";

export default node;
